"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteItems = exports.prependItem = exports.addItem = exports.setHeaderItems = exports.setItems = exports.setResult = exports.reset = exports.PREPEND_ITEM = exports.DELETE_ITEMS = exports.ADD_ITEM = exports.SET_HEADER_ITEMS = exports.SET_ITEMS = exports.SET_RESULT = exports.RESET = exports.MULTI = void 0;
exports.MULTI = "multi";
exports.RESET = "multi/reset";
exports.SET_RESULT = "multi/setResult";
exports.SET_ITEMS = "multi/setItems";
exports.SET_HEADER_ITEMS = "multi/setHeaderItems";
exports.ADD_ITEM = "multi/addItem";
exports.DELETE_ITEMS = "multi/deleteItems";
exports.PREPEND_ITEM = "multi/prependItem";
var reset = function (module) { return ({
    type: exports.MULTI,
    payload: {
        module: module,
        subtype: exports.RESET,
    },
}); };
exports.reset = reset;
var setResult = function (module, queryHash, result) { return ({
    type: exports.MULTI,
    payload: {
        module: module,
        subtype: exports.SET_RESULT,
        queryHash: queryHash,
        result: result,
    },
}); };
exports.setResult = setResult;
var setItems = function (module, items) { return ({
    type: exports.MULTI,
    payload: {
        module: module,
        subtype: exports.SET_ITEMS,
        items: items,
    },
}); };
exports.setItems = setItems;
var setHeaderItems = function (module, items) { return ({
    type: exports.MULTI,
    payload: {
        module: module,
        subtype: exports.SET_HEADER_ITEMS,
        items: items,
    },
}); };
exports.setHeaderItems = setHeaderItems;
var addItem = function (module, item) { return ({
    type: exports.MULTI,
    payload: {
        module: module,
        subtype: exports.ADD_ITEM,
        item: item,
    },
}); };
exports.addItem = addItem;
var prependItem = function (module, item, queryHash) { return ({
    type: exports.MULTI,
    payload: {
        module: module,
        queryHash: queryHash,
        subtype: exports.PREPEND_ITEM,
        item: item,
    },
}); };
exports.prependItem = prependItem;
var deleteItems = function (module, ids) { return ({
    type: exports.MULTI,
    payload: {
        module: module,
        subtype: exports.DELETE_ITEMS,
        ids: ids,
    },
}); };
exports.deleteItems = deleteItems;
